{
    "program": [
      {
        "programTypeGuid": "D972DA85-0565-4971-B031-FC44878C6EA9",
        "page": {
          "pageKey": "event-registration",
          "workshop": [
            {
              "workshopTypeId": 9,
              "model": {
                "expiryDays": 60
              }
            },
            {
              "workshopTypeId": null,
              "model": {
                "expiryDays": 90,
                "EventIdTitle":"Event Id"
              }
            }
          ]
        }
      },
      {
        "programTypeGuid": "C5D3A897-C737-4EEC-BFC7-D9FF1FB7F315",
        "page": {
          "pageKey": "mrpp-registration",
          "workshop": [
            {
              "workshopTypeId": 10,         
              "model": {
                "expiryDays": 30
              }
            },
            {
              "workshopTypeId": 11,         
              "model": {
                "expiryDays": 90,
                "EventIdTitle":"Engagement Id"
              }
            },
            {
              "workshopTypeId": null,          
              "model": {
                "expiryDays": 60
              }
            }
          ]          
        }
      }
    ]
}